import { Injectable, inject } from '@angular/core';
import { CanActivate } from '@angular/router';
import { RouteGuardService } from './service/route-guard.service';
import { View } from '../layout/model/interfaces/view.interface';

@Injectable({ providedIn: 'root' })
export class ProcessUploadViewGuard implements CanActivate {
  private routeGuardService = inject(RouteGuardService);

  async canActivate(): Promise<boolean> {
    const view = this.getView();
    if (view) {
      const shouldNavigate = await this.routeGuardService.handleRoute(view);
      return shouldNavigate;
    }
    return true;
  }

  getView(): View {
    return {
      route: 'workflows2/upload',
      iframeUrl: 'workflows2/upload',
    };
  }
}
